export default {
    name: 'categorias',
    component: () => import(/* webpackChunkName: "General" */ '@/layouts/General.vue'),
    children: [
        {
            path: '',
            name: 'home-categorias',
            component: () => import('@/modules/categorias/view/Home.vue'),
        },
        {
            path: 'add',
            name: 'add-categorias',
            component: () => import('@/modules/categorias/view/Add.vue'),
            props: (route) => {
                return {
                    id: 'new'
                }
            }
        },
        {
            path: ':id',
            name: 'edit-categorias',
            component: () => import('@/modules/categorias/view/Add.vue'),
            props: (route) => {
                return {
                    id: route.params.id
                }
            }
        }
    ]
}